module.exports = __webpack_public_path__ + "img/trash-slash.de5b45cd.svg";